<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YaqnhD/tc-custom/9781398478770.jpg?1685327173654" alt="This image is the cover for the book Accepting ME"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Accepting ME
      </h1>
      <p class="bookDescription body article font2">
        <p>What do you do when your life is turned upside down by an illness? Learning to adapt and cope with illness is extremely difficult and can lead even the most confident person to becoming vulnerable. Follow Lou through her fascinating true journey of how she learned to live with her illness and how she discovered a way to live again.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lou Clarke
      </h2>
      
      <p class="authorDescription body article">Lou Clarke worked extensively in the financial industry for many years, and has not only lived in the UK and the Channel Islands, but also Spain and more recently Portugal. Her interests include spending time with her husband and their two children, and walking their two dogs along the sandy beaches where she now lives. Being an avid reader, Lou has finally decided to pen her first book, which she hopes will be beneficial to others.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?49065078